module.exports = __webpack_public_path__ + "img/reward-settings.fd683424.png";